export default __webpack_public_path__ + "static/media/icon-orders-active.6da89c25.svg";